export const apricotVersion = '4.8.0';
